export enum ADDRESS_TYPE {
  SERVICE = 'SERVICE',
  BILLING = 'BILLING'
}

export const initialAddressState = {
  id: 0,
  street: '',
  addressName: '',
  addressNote: '',
  apartment: '',
  city: '',
  country: '',
  zipCode: '',
  state: '',
  latitude: 0,
  longitude: 0
};
